<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="CX942, CX943, CX944, XC9445, XC9455, XC9465 MFP's">
     CX942, CX943, CX944, XC9445, XC9455, XC9465 MFP's
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_nl" title="Informatie over veiligheid">
     Informatie over veiligheid
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Conventies">
      Conventies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e40" title="Productverklaringen">
      Productverklaringen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_nl" title="Over de printer">
     Over de printer
    </a>
   </p>
   <div id="divd0e170">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_nl" title="Informatie zoeken over de printer">
      Informatie zoeken over de printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_nl" title="Het serienummer van de printer zoeken">
      Het serienummer van de printer zoeken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_nl" title="Printerconfiguraties">
      Printerconfiguraties
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_nl" title="Het bedieningspaneel gebruiken">
      Het bedieningspaneel gebruiken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_nl" title="Uitleg over de status van het indicatielampje">
      Uitleg over de status van het indicatielampje
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e560" title="Papier selecteren">
      Papier selecteren
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_nl" title="Installeren, instellen en configureren">
     Installeren, instellen en configureren
    </a>
   </p>
   <div id="divd0e5309">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_nl" title="Een locatie voor de printer selecteren">
      Een locatie voor de printer selecteren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_nl" title="Kabels aansluiten">
      Kabels aansluiten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#d0e5492" title="Toepassingen van het startscherm instellen en gebruiken">
      Toepassingen van het startscherm instellen en gebruiken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e6012" title="De toegankelijkheidsfuncties instellen en gebruiken">
      De toegankelijkheidsfuncties instellen en gebruiken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e6315" title="Printer instellen voor faxen">
      Printer instellen voor faxen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_nl" title="De SMTP-instellingen voor e-mail configureren">
      De SMTP-instellingen voor e-mail configureren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_nl" title="Papier en speciaal afdrukmateriaal plaatsen">
      Papier en speciaal afdrukmateriaal plaatsen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e8574" title="Software, stuurprogramma's en firmware installeren en bijwerken">
      Software, stuurprogramma's en firmware installeren en bijwerken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-envelope-tray-topic.html#d0e8856" title="Hardwareopties installeren">
      Hardwareopties installeren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="networking-intro-topic.html#d0e9834" title="Netwerk">
      Netwerk
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_nl" title="Printer beveiligen">
     Printer beveiligen
    </a>
   </p>
   <div id="divd0e10223">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_nl" title="De beveiligingssleuf vinden">
      De beveiligingssleuf vinden
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_nl" title="Printergeheugen wissen">
      Printergeheugen wissen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_nl" title="Bezig met wissen van opslagstation van printer">
      Bezig met wissen van opslagstation van printer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_nl" title="Fabrieksinstellingen herstellen">
      Fabrieksinstellingen herstellen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_nl" title="Kennisgeving van vluchtigheid">
      Kennisgeving van vluchtigheid
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_nl" title="Afdrukken">
     Afdrukken
    </a>
   </p>
   <div id="divd0e10415">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_nl" title="Afdrukken vanaf een computer">
      Afdrukken vanaf een computer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e10441" title="Afdrukken vanaf een mobiel apparaat">
      Afdrukken vanaf een mobiel apparaat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-booklet-topic.html#printing-booklet_nl" title="Een boekje afdrukken">
      Een boekje afdrukken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_nl" title="Afdrukken vanaf een flashstation">
      Afdrukken vanaf een flashstation
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_nl" title="Ondersteunde flashstations en bestandstypen">
      Ondersteunde flashstations en bestandstypen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_nl" title="Beveiligde taken configureren">
      Beveiligde taken configureren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_nl" title="Afdrukken van vertrouwelijke taken en andere taken in de wachtrij">
      Afdrukken van vertrouwelijke taken en andere taken in de wachtrij
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_nl" title="Lijst met voorbeelden van lettertypen afdrukken">
      Lijst met voorbeelden van lettertypen afdrukken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_nl" title="Een directorylijst afdrukken">
      Een directorylijst afdrukken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_nl" title="Scheidingsvellen invoegen tussen exemplaren">
      Scheidingsvellen invoegen tussen exemplaren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stapling-printed-sheets-topic.html#stapling-printed-sheets_nl" title="Afgedrukte vellen nieten">
      Afgedrukte vellen nieten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="punching-holes-printed-sheets-topic.html#punching-holes-printed-sheets_nl" title="Afgedrukte vellen perforeren">
      Afgedrukte vellen perforeren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="folding-printed-sheets-topic.html#folding-printed-sheets_nl" title="Afgedrukte vellen vouwen">
      Afgedrukte vellen vouwen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacking-printed-sheets-topic.html#using-offset-stacking-printed-sheets_nl" title="Gescheiden stapelen in afgedrukte vellen gebruiken">
      Gescheiden stapelen in afgedrukte vellen gebruiken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_nl" title="Afdruktaak annuleren">
      Afdruktaak annuleren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_nl" title="Tonerintensiteit aanpassen">
      Tonerintensiteit aanpassen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_nl" title="Kopi&euml;ren">
     Kopi&euml;ren
    </a>
   </p>
   <div id="divd0e11276">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_nl" title="De automatische documentinvoer en glasplaat gebruiken">
      De automatische documentinvoer en glasplaat gebruiken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_nl" title="Kopie&euml;n maken">
      Kopie&euml;n maken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_nl" title="Foto's kopi&euml;ren">
      Foto's kopi&euml;ren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_nl" title="Kopi&euml;ren op briefhoofdpapier">
      Kopi&euml;ren op briefhoofdpapier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_nl" title="Op beide zijden van het papier kopi&euml;ren">
      Op beide zijden van het papier kopi&euml;ren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_nl" title="Kopie&euml;n verkleinen of vergroten">
      Kopie&euml;n verkleinen of vergroten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_nl" title="Exemplaren sorteren">
      Exemplaren sorteren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_nl" title="Scheidingsvellen invoegen tussen exemplaren">
      Scheidingsvellen invoegen tussen exemplaren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_nl" title="Meerdere pagina's op &eacute;&eacute;n vel kopi&euml;ren">
      Meerdere pagina's op &eacute;&eacute;n vel kopi&euml;ren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_nl" title="Passen kopi&euml;ren">
      Passen kopi&euml;ren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stapling-copies-topic.html#stapling-copies_nl" title="Kopie&euml;n nieten">
      Kopie&euml;n nieten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="punching-holes-copies-topic.html#punching-holes-copies_nl" title="Perforeren in kopie&euml;n">
      Perforeren in kopie&euml;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-booklet-from-copied-documents-topic.html#creating-booklet-from-copied-documents_nl" title="Een boekje maken van gekopieerde documenten">
      Een boekje maken van gekopieerde documenten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="folding-copies-topic.html#folding-copies_nl" title="Kopie&euml;n vouwen">
      Kopie&euml;n vouwen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacking-copies-topic.html#using-offset-stacking-copies_nl" title="Gescheiden stapelen gebruiken in kopie&euml;n">
      Gescheiden stapelen gebruiken in kopie&euml;n
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_nl" title="Een kopieersnelkoppeling maken">
      Een kopieersnelkoppeling maken
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_nl" title="E-mail">
     E-mail
    </a>
   </p>
   <div id="divd0e11706">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_nl" title="De automatische documentinvoer en glasplaat gebruiken">
      De automatische documentinvoer en glasplaat gebruiken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_nl" title="Een e-mail verzenden">
      Een e-mail verzenden
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_nl" title="Een e-mailsnelkoppeling maken">
      Een e-mailsnelkoppeling maken
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_nl" title="Faxen">
     Faxen
    </a>
   </p>
   <div id="divd0e11801">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_nl" title="De automatische documentinvoer en glasplaat gebruiken">
      De automatische documentinvoer en glasplaat gebruiken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_nl" title="Een fax verzenden">
      Een fax verzenden
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_nl" title="Een fax plannen">
      Een fax plannen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_nl" title="Een snelkoppeling voor een faxbestemming maken">
      Een snelkoppeling voor een faxbestemming maken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_nl" title="De faxresolutie wijzigen">
      De faxresolutie wijzigen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_nl" title="Faxintensiteit aanpassen">
      Faxintensiteit aanpassen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_nl" title="Faxlog afdrukken">
      Faxlog afdrukken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_nl" title="Ongewenste faxen blokkeren">
      Ongewenste faxen blokkeren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_nl" title="Faxen in wachtrij">
      Faxen in wachtrij
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_nl" title="Een fax doorsturen">
      Een fax doorsturen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_nl" title="Scannen">
     Scannen
    </a>
   </p>
   <div id="divd0e12165">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_nl" title="De automatische documentinvoer en glasplaat gebruiken">
      De automatische documentinvoer en glasplaat gebruiken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_nl" title="Naar een computer scannen">
      Naar een computer scannen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_nl" title="Naar een FTP-server scannen">
      Naar een FTP-server scannen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_nl" title="Een FTP-snelkoppeling maken">
      Een FTP-snelkoppeling maken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_nl" title="Scannen naar een netwerkmap">
      Scannen naar een netwerkmap
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_nl" title="snelkoppeling voor netwerkmap maken">
      snelkoppeling voor netwerkmap maken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_nl" title="Scannen naar een flashstation">
      Scannen naar een flashstation
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_nl" title="Printermenu's gebruiken">
     Printermenu's gebruiken
    </a>
   </p>
   <div id="divd0e12467">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_nl" title="Menu-overzicht">
      Menu-overzicht
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e12832" title="Apparaat">
      Apparaat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e15396" title="Afdrukken">
      Afdrukken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e16802" title="Papier">
      Papier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e17145" title="Kopi&euml;ren">
      Kopi&euml;ren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e17806" title="Faxen">
      Faxen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e20163" title="E-mail">
      E-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e21213" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e21798" title="USB-station">
      USB-station
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e22656" title="Netwerk/poorten">
      Netwerk/poorten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e24837" title="Cloud Services">
      Cloud Services
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e24894" title="Beveiliging">
      Beveiliging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e26083" title="Rapporten">
      Rapporten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-topic.html#help_nl" title="Help">
      Help
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_nl" title="Problemen oplossen">
      Problemen oplossen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_nl" title="De Pagina met menu-instellingen afdrukken">
      De Pagina met menu-instellingen afdrukken
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_nl" title="Printer onderhouden">
     Printer onderhouden
    </a>
   </p>
   <div id="divd0e26517">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_nl" title="De status van de onderdelen en supplies controleren">
      De status van de onderdelen en supplies controleren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_nl" title="Meldingen over supplies configureren">
      Meldingen over supplies configureren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_nl" title="E-mailmeldingen instellen">
      E-mailmeldingen instellen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_nl" title="Rapporten weergeven">
      Rapporten weergeven
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_nl" title="Onderdelen en supplies bestellen">
      Onderdelen en supplies bestellen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e26798" title="Onderdelen en supplies vervangen">
      Onderdelen en supplies vervangen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e27785" title="Printeronderdelen reinigen">
      Printeronderdelen reinigen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e28086" title="Energie en papier besparen">
      Energie en papier besparen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_nl" title="De printer verplaatsen naar een andere locatie">
      De printer verplaatsen naar een andere locatie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_nl" title="De printer vervoeren.">
      De printer vervoeren.
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_nl" title="Problemen oplossen">
     Problemen oplossen
    </a>
   </p>
   <div id="divd0e28239">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_nl" title="Problemen met de afdrukkwaliteit">
      Problemen met de afdrukkwaliteit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_nl" title="Printerfoutcodes">
      Printerfoutcodes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_nl" title="Afdrukproblemen">
      Afdrukproblemen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_nl" title="De printer reageert niet">
      De printer reageert niet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_nl" title="Flashstation kan niet worden gelezen">
      Flashstation kan niet worden gelezen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_nl" title="USB-poort activeren">
      USB-poort activeren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_nl" title="Papierstoringen verhelpen">
      Papierstoringen verhelpen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e32450" title="Problemen met de netwerkverbinding">
      Problemen met de netwerkverbinding
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e32678" title="Problemen met hardwareopties">
      Problemen met hardwareopties
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-missing-or-unresponsive-toner-cartridge-topic.html#d0e32804" title="Problemen met supplies">
      Problemen met supplies
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e32909" title="Problemen met de papierinvoer">
      Problemen met de papierinvoer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e33275" title="E-mailproblemen">
      E-mailproblemen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e33369" title="Problemen met faxen">
      Problemen met faxen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e34014" title="Problemen met scannen">
      Problemen met scannen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e34801" title="Problemen met kleurkwaliteit">
      Problemen met kleurkwaliteit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_nl" title="Contact opnemen met de klantenondersteuning">
      Contact opnemen met de klantenondersteuning
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_nl" title="Recyclen en wegdoen">
     Recyclen en wegdoen
    </a>
   </p>
   <div id="divd0e35051">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_nl" title="Lexmark-producten recyclen">
      Lexmark-producten recyclen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_nl" title="Lexmark-verpakkingsmateriaal recyclen">
      Lexmark-verpakkingsmateriaal recyclen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_nl" title="Kennisgevingen">
     Kennisgevingen
    </a>
   </p>
   <div id="divd0e35086">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e35089" title="Productinformatie">
      Productinformatie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e35106" title="Kennisgeving over deze editie">
      Kennisgeving over deze editie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_nl" title="Handelsmerken">
      Handelsmerken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_nl" title="Licentiemeldingen">
      Licentiemeldingen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_nl" title="Geluidsniveaus">
      Geluidsniveaus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_nl" title="AEEA-richtlijn (Afgedankte elektrische en elektronische apparatuur)">
      AEEA-richtlijn (Afgedankte elektrische en elektronische apparatuur)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e35212" title="Oplaadbare lithium-ionbatterij">
      Oplaadbare lithium-ionbatterij
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_nl" title="Verordening (EU) 2023/1542">
      Verordening (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e35249" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_nl" title="Verwijdering van het product">
      Verwijdering van het product
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_nl" title="Lexmark cartridges terugsturen voor hergebruik of recycling">
      Lexmark cartridges terugsturen voor hergebruik of recycling
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_nl" title="Kennisgeving over gevoeligheid voor statische elektriciteit">
      Kennisgeving over gevoeligheid voor statische elektriciteit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_nl" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_nl" title="Temperatuurinformatie">
      Temperatuurinformatie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_nl" title="Energieverbruik">
      Energieverbruik
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_nl" title="Kennisgevingen over regelgeving met betrekking tot terminalapparatuur voor telecommunicatie">
      Kennisgevingen over regelgeving met betrekking tot terminalapparatuur voor telecommunicatie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_nl" title="Voorschriften van de Europese Gemeenschap (EG)">
      Voorschriften van de Europese Gemeenschap (EG)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_nl" title="Kennisgeving van radiostoring">
      Kennisgeving van radiostoring
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue